import React, { useEffect, useState } from "react";
import classNames from "classnames";
import {
  useDocTypeName,
  useChildCategoryApi,
  useQuestionContentListApi,
} from "./hooks";
import ArticleDetail from "./ArticleDetail";
import style from "./index.module.scss";

const Document = ({ docType }) => {
  const [docTypeName] = useDocTypeName(docType, "");
  const [categoryListVisible, setCategoryListVisible] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [currentArticle, setCurrentArticle] = useState({});
  const [tabChange, setTabChange] = useState(false);

  const [getChildCategory] = useChildCategoryApi(docType);
  const [childCategory, setChildCategory] = useState([]);
  const [getQuestionDetail] = useQuestionContentListApi(docType);
  const [questionDetail, setQuestionDetail] = useState([]);
  const [idIndex, setIdIndex] = useState("");

  const [catName,setCatName] = useState('');

  useEffect(() => {
    getChildCategory()
      .then(function (response) {
        if (response.status === 200) {
          const result = response.data;
          if (result.success) {
            const data = result.result.children;
            let categoryId = getQueryVariable('categoryid');//获取类目的id
            // setCurrentCategory(categoryId);
            let id = getQueryVariable('id');//右侧展示的问题的id

            if(!categoryId) {
              categoryId = data[0].children.length ? data[0].children[0].categoryId : data[0].categoryId
            }

            for(let i = 0; i < data.length; i++) {
              let item = data[i];
              if(item.categoryId === categoryId) {
                data[i].selected = true;
                break;
              }
              if(item.children.length) {
                if(item.children.findIndex(item => item.categoryId == categoryId) > -1) {
                  data[i].selected = true;
                  break;
                }
              }
            }

            console.log(data)
            
            setIdIndex(categoryId);
            
            setChildCategory(data);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if(idIndex) {
      getQuestionDetail({
        categoryId: idIndex,
      })
        .then(function (response) {
          if (response.status === 200) {
            const result = response.data;
            if (result.success) {
              const data = result.result.items;
              // if (tabChange == false && getQueryVariable("id")) {
              //   setCurrentArticle({
              //     categoryId: getQueryVariable("id"),
              //   });
              // } else {
              //   setCurrentArticle(data[0] || {});
              // }
              setQuestionDetail(data);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [idIndex]); //eslint-disable-line
  function changeURLPar(uri, par, par_value) {
    var pattern = par + "=([^&]*)";
    var replaceText = par + "=" + par_value;
    if (uri.match(pattern)) {
      //如果连接中带这个参数
      var tmp = "/\\" + par + "=[^&]*/";
      tmp = uri.replace(eval(tmp), replaceText);
      return tmp;
    } else {
      if (uri.match("[?]")) {
        //如果链接中不带这个参数但是有其他参数
        return uri + "&" + replaceText;
      } else {
        //如果链接中没有带任何参数
        return uri + "?" + replaceText;
      }
    }
  }
  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return "";
  }

  function handleToggleCategoryList() {
    log("vop_open_pc", "vop_open_doc", idIndex);
    setCategoryListVisible(!categoryListVisible);
  }

  function handleCategoryChange(category, index) {
    log(
      "vop_open_pc",
      "vop_open_doc",
      currentCategory.categoryParentId,
      category.categoryId
    );
    childCategory[index].selected = !childCategory[index].selected;

    if (!(category.children && category.children.length !== 0)) {
      window.scrollTo(0, 0);
      location.href = `/doc/faq?categoryid=${category.categoryId}`
      // setCurrentArticle(category);
      // setIdIndex(category.categoryId);
    }
    setCatName(category.categoryName);
  }
  function handleArticleChange(article) {
    log(
      "vop_open_pc",
      "vop_open_doc",
      currentCategory.categoryParentId,
      article.categoryId,
      article.articleId
    );
    window.scrollTo(0, 0);
    location.href = `/doc/faq?categoryid=${article.categoryId}`
    // setCurrentArticle(article);
    // setIdIndex(article.categoryId);
  }

  return (
    <div className={`${style.app}`}>
      <div className={`${style.header}`}>
        <div className={`${style.content}`}>
          <div className={`${style.title}`}>
            <img
              className={`${style.icon}`}
              src="https://img10.360buyimg.com/imagetools/jfs/t1/148978/22/11041/349/5f885534E349dd29e/3f847fcbe5316650.png"
              alt=""
            />
            <div className={`${style.text}`}>{docTypeName}</div>
          </div>
          <div className={`${style.breadcrumb}`}>
            <span className={`${style.level1}`}>{docTypeName}</span>
            <span className={`${style.separator}`}>/</span>
            <span className={`${style.level2}`}>
              {catName}
            </span>
            <span className={`${style.separator}`}>/</span>
            <span className={`${style.level3}`}>
            {currentArticle.articleName}
            </span>
          </div>
        </div>
      </div>
      <div className={`${style.main}`}>
        <div className={`${style.sidebar}`}>
          <div
            className={`${style.categoryMenu}`}
            onClick={handleToggleCategoryList}
          >
            {childCategory.map((category, index) => (
              <div
                className={classNames(`${style.categoryItem}`, {
                  [`${style.selected}`]:
                    idIndex === category.categoryId && (category.children.length==0 || !category.children) ,
                })}
                key={category.categoryId}
                title={category.categoryName}
                onClick={() => handleCategoryChange(category, index)}
              >
                <span
                  className={classNames(`${style.categoryMenuTitle}`)}
                >{`${category.categoryName.substr(0, 10)}`}</span>
                <div className={`${style.icon}`}>
                  {(category.children.length !==0 || !category.children) ? (
                    <div>
                      {category.selected ? (
                        <img
                          src="https://s2-relay.360buyimg.com/relay/cache/cut/8b8f22934ce58900efa8569c56a26279"
                          alt=""
                        />
                      ) : (
                        <img
                          src="https://img12.360buyimg.com/imagetools/jfs/t1/136955/36/13151/383/5f904fa6E5a763cdc/ea07ac64495d1923.png"
                          alt=""
                        />
                      )}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>

                {category.selected ? (
                  <div>
                    {category.children &&
                      category.children.map((article) => {
                        return (
                          <div
                            key={article.categoryId}
                            className={classNames(
                              `${style.categoryListChild}`,
                              {
                                [`${style.selected}`]:
                                  idIndex === article.categoryId,
                              }
                            )}
                            title={article.categoryName}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleArticleChange(article);
                            }}
                          >
                            {article.categoryName}
                          </div>
                        );
                      })}{" "}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
        <div className={`${style.content} __html`}>
          <ArticleDetail detail={questionDetail} />
        </div>
      </div>
    </div>
  );
};

export default Document;
